import client from '/src/services/client.js';

export default {
    getChannels : (data) => client.get('channels', data),
    getChannelPhonesAvailable : (id) => client.get(`channel/${id}/phones_available`),
    getChannelsAutocomplete : (name) => client.get(`channels?name=${name}`),
    getChannel : (name,data)=> client.get(`channel/${name}`, data),
    addChannel: (data)=> client.post(`channel`, data),
    deleteChannel : (id)=> client.delete(`channel/${id}`),
    updateChannel: (id, data) => client.put(`channel/${id}`, data),
    revokeRcsCredentials: (id) => client.delete(`channel/${id}/rcs-credentials`),
    revealRcsPassword: (id) => client.get(`channel/${id}/rcs-credentials/password`),
}